import {  Switch, styled } from "@mui/material";

import { useSettingsContext } from "src/components/settings";


const ThemeModeButton: React.FC = () => {

  const settings = useSettingsContext();

  const MaterialUISwitch = styled(Switch)(({ theme }) => ({
    width: 58,
    height: 30,
    padding: 7,
    margin: '0 !important',
    '& .MuiSwitch-switchBase': {
      margin: 1,
      padding: 0,
      left: 0,
      transform: 'translateX(6px)',
      '&.Mui-checked': {
        color: '#fff',
        transform: 'translateX(22px)',
        '& .MuiSwitch-thumb:before': {
          backgroundImage: `url('/assets/icons/setting/ic_moon.svg')`,
        },
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: theme.palette.primary.main,
      width: 28,
      height: 28,
      '&::before': {
        content: "''",
        position: 'absolute',
        margin: '18%',
        width: '64%',
        height: '64%',
        left: 0,
        top: 0,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url('/assets/icons/setting/ic_sun.svg')`,
      },
    },
    '& .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
      borderRadius: 20 / 2,
    },
  }));

  return (
    <MaterialUISwitch sx={{ m: 1 }} checked={settings.themeMode === 'dark'} onChange={(_, checked) => settings.onUpdate('themeMode', checked ? 'dark': 'light' )} />
  );
}


export default ThemeModeButton;
